<template>
  <div
    class="card"
    :class="[
      { 'card-plain': plain },
      { 'card-raised': raised },
      { [`card-${type}`]: type }
    ]"
    :data-background-color="color"
  >
    <h6 class="card-category" v-if="$slots.category || category">
      {{ category }}
    </h6>
    <div class="card-image" v-if="$slots.image">
      <slot name="image"></slot>
    </div>

    <div class="card-avatar" v-if="$slots.avatar">
      <slot name="avatar"></slot>
    </div>

    <div class="info" v-if="$slots.info">
      <slot name="info"></slot>
    </div>

    <div
      class="card-header"
      :class="headerClasses"
      v-if="$slots.header || title"
    >
      <slot name="header">
        <h1 v-if="title" class="card-title">{{ title }}</h1>
        <h3 v-if="subTitle" class="card-category">{{ subTitle }}</h3>
        <p v-if="description" class="card-description">{{ description }}</p>
      </slot>
    </div>
    <div v-if="$slots.default" class="card-body" :class="cardBodyClasses">
      <slot></slot>
    </div>

    <slot name="raw-content"></slot>

    <hr v-if="$slots.footer && !noFooterLine" />
    <div class="card-footer" v-if="$slots.footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'card',
    props: {
      type: String,
      title: String,
      subTitle: String,
      category: String,
      color: String,
      description: String,
      noFooterLine: Boolean,
      plain: Boolean,
      raised: Boolean,
      cardBodyClasses: [String, Object, Array],
      headerClasses: [String, Object, Array],
    },
  };
</script>
<style lang="scss" scoped>
  .card-image {
    min-height: calc(100% - 65px);
    background: url('data:image/png;base64,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') center;
  }

  .card-text {
    max-height: 65px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
